import { render, staticRenderFns } from "./config-edit.vue?vue&type=template&id=3fc52403&scoped=true&"
import script from "./config-edit.vue?vue&type=script&lang=js&"
export * from "./config-edit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=3fc52403&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc52403",
  null
  
)

component.options.__file = "config-edit.vue"
export default component.exports